import { BREAKPOINTS } from "layout";
import styled from "styled-components";

export const DimensionsBox = styled.div`
  display: flex;
  gap: 4px;
  width: 100%;
  padding: 8px 16px;
  align-items: center;
  background: #f4f5f6;
  border: 1px solid #e8e8e8;
  border-radius: 4px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    margin-top: 14px;
  }
`;

export const DimensionsTitleWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 12px;
`;

export const DimensionsLabel = styled.span`
  color: #3b3f45;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.8px;
  letter-spacing: -0.28px;
`;

export const Dimensions = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DimensionContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 1px solid #dee0e3;
  padding-left: 12px;
`;

export const DimensionsItem = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.28px;
  color: #676f79;
`;
